﻿import React, { useEffect, useState } from "react";

export default function CarInformation({ data }) {

    const [carInfo, setCarInfo] = useState(data);
    const [sessionCookieUpdated, setSessionCookieUpdated] = useState(false);

    useEffect(() => {
        if (window.sessionStorage) {
            const carInformation = sessionStorage.getItem("carInformation");
            if (carInformation) {
                setSessionCookieUpdated(true);
            }
        }
    }, []);

    useEffect(() => {
        if (!data) {
            if (window.sessionStorage) {
                setCarInfo(sessionStorage.getItem("car"));
            }
        }
    }, [data]);

    const removeCarInfo = () => {
        sessionStorage.removeItem("carInformation");
        document.getElementById("greenDot").style.display = "none";
        document.getElementById('carInformation').style.display = "none";
        setSessionCookieUpdated(false);
    }

    return (
        <div>
            {carInfo && sessionCookieUpdated ?
                <div>
                    <div className="carInformationRemove">
                        <button onClick={removeCarInfo}>
                            <img src="/images/RemoveCarInfo.svg" />Fjern
                        </button>
                    </div>
                    <div className="carInformationValuesContainer">
                        <ul className="carInformationList">
                            {carInfo.map((info) => {
                                if (info.Value === "" || info.Value === null || info.Value === undefined) {
                                    return null;
                                }
                                return (
                                    <li key={info.Key} style={{ display: "flex", flexDirection: "column" }}>
                                        <label className="carInformationKey">{info.Key}</label>
                                        <span className="carInformationValue">{info.Value}</span>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
                : <h3 className="carInfoEmptyContent">Hvis du søker på reg.nr. vil du få informasjon om kjøretøyet her.
                Gå til startsiden for å søke på regnr</h3>}
            <div className="carInfoClose" id="closeCarInfo">
                <img id="closeCarInfoIcon" src="/images/CaretUpSmall.svg" />
            </div>
        </div>
    );

}